import React from "react";

const TemarioPosgradoToxicologia = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Fundamentos de toxicología"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Introducción a la toxicología"}</span></li>
                <li><span className="fw-light">{"Historia y evolución de la toxicología"}</span></li>
                <li><span className="fw-light">{"Estadísticas y carga de enfermedad relacionada a intoxicaciones"}</span></li>
                <li><span className="fw-light">{"Principios generales y clasificaciones"}</span></li>
                <li><span className="fw-light">{"Vías de exposición y mecanismos de toxicidad"}</span></li>
                <li><span className="fw-light">{"Abordaje general del paciente intoxicado"}</span></li>
                <li><span className="fw-light">{"Abordaje médico-legal de intoxicaciones"}</span></li>
                <li><span className="fw-light">{"Prácticas útiles en toxicología"}</span></li>
                <li><span className="fw-light">{"Síntomas y tóxicos: enfoque sindrómico"}</span></li>
                <li><span className="fw-light">{"Antídotos: generalidades"}</span></li>
            </ul>
            <br /><br />
            <b>{"Toxicología clínica"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Intoxicaciones por productos de uso doméstico"}</span></li>
                <li><span className="fw-light">{"Intoxicaciones alimentarias"}</span></li>
                <li><span className="fw-light">{"Intoxicación por medicamentos I"}</span></li>
                <li><span className="fw-light">{"Intoxicación por medicamentos II"}</span></li>
                <li><span className="fw-light">{"Intoxicaciones frecuentes en la infancia"}</span></li>
                <li><span className="fw-light">{"Intoxicación por gases tóxicos"}</span></li>
                <li><span className="fw-light">{"Intoxicación por monóxido de carbono"}</span></li>
            </ul>
            <br /><br />
            <b>{"Toxicología ambiental y animales venenosos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Nociones básicas de toxicología ambiental y ecotoxicología"}</span></li>
                <li><span className="fw-light">{"Evaluación de riesgo ambiental"}</span></li>
                <li><span className="fw-light">{"Exposición crónica a contaminantes"}</span></li>
                <li><span className="fw-light">{"Animales venenosos autóctonos"}</span></li>
                <li><span className="fw-light">{"Animales exóticos venenosos"}</span></li>
                <li><span className="fw-light">{"Intoxicación por plantas"}</span></li>
                <li><span className="fw-light">{"Intoxicación por plaguicidas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Toxicología ocupacional y forense"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Toxicología laboral: evaluación de riesgos en ambientes de trabajo"}</span></li>
                <li><span className="fw-light">{"Intoxicaciones en el ámbito ocupacional"}</span></li>
                <li><span className="fw-light">{"Diagnóstico y seguimiento de exposición laboral a tóxicos"}</span></li>
                <li><span className="fw-light">{"Armas químicas y agentes tóxicos"}</span></li>
                <li><span className="fw-light">{"Intoxicación por cáusticos"}</span></li>
                <li><span className="fw-light">{"Intoxicación por hidrocarburos"}</span></li>
                <li><span className="fw-light">{"Intoxicación por metales pesados"}</span></li>
                <li><span className="fw-light">{"Radiación y efectos toxicológicos"}</span></li>
            </ul>
            <br /><br />
            <b>{"Neurobiología, sustancias de abuso y prevención"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Neurobiología de las adicciones"}</span></li>
                <li><span className="fw-light">{"Mecanismos neuroquímicos del consumo problemático"}</span></li>
                <li><span className="fw-light">{"Drogas de abuso: alcohol, cocaína, cannabis, benzodiacepinas, opioides"}</span></li>
                <li><span className="fw-light">{"Drogas sintéticas emergentes"}</span></li>
                <li><span className="fw-light">{"Precursores químicos"}</span></li>
                <li><span className="fw-light">{"Consumo y gestación"}</span></li>
                <li><span className="fw-light">{"Evaluación del consumo problemático"}</span></li>
                <li><span className="fw-light">{"Gestión de políticas públicas orientadas a la prevención de la oferta"}</span></li>
                <li><span className="fw-light">{"Gestión de políticas públicas orientadas a la prevención de la demanda"}</span></li>
            </ul>
            <br /><br />
            <b>{"Toxicología aplicada al consultorio y a la práctica clínica"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Toxicología en el consultorio"}</span></li>
                <li><span className="fw-light">{"Errores frecuentes en toxicología clínica"}</span></li>
                <li><span className="fw-light">{"Taller práctico I"}</span></li>
                <li><span className="fw-light">{"Taller práctico II"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioPosgradoToxicologia;
